import { render, staticRenderFns } from "./RegionCenter.vue?vue&type=template&id=084d4297&"
import script from "./RegionCenter.vue?vue&type=script&lang=js&"
export * from "./RegionCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports